export function request(data) {
    data = Object.assign({}, data);

    Object.keys(data).forEach((key) => {
        if (data[key] === '') {
            delete data[key];
        }
    });

    return {
        type: 'CUSTOMERS_FIND_REQUEST',
        data
    };
}

export function error(errors) {
    return {
        type: 'CUSTOMERS_FIND_ERROR',
        errors
    };
}

export function finish(customers) {
    return {
        type: 'CUSTOMERS_FIND_FINISH',
        customers
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_FIND_CLEAR'
    };
}
